/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Website } from '@app/settings/websites/website.model';
import { WebsitesFormComponent } from '@app/settings/websites/websites-form/websites-form.component';

@Injectable({
  providedIn: 'root',
})
export class WebsitesFormService {
  constructor(private modalService: NgbModal) {}

  public open(website: null | Website = null): Promise<any> {
    const modal = this.modalService.open(WebsitesFormComponent, { size: 'lg' });
    modal.componentInstance.website = website;
    return modal.result;
  }
}
